import * as actions from './state/actions';

export const eventsMap = {
  // View/Search for Products
  [actions.ActionTypes.BIN_SEARCH_SUCCESS]: (action: actions.BinSearchSuccessAction): any => {
    return {
      hitType: 'transaction',
      data: action.payload
    }
  },
  // Add product to shopping card
  [actions.ActionTypes.SELECT_CARD_TYPE]: (action: actions.SelectCardTypeAction): any => {
    return {
      hitType: 'transaction',
      data: action.payload
    }
  }
};